import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { FrequencyPicker } from "@/components/FrequencyPicker";
import { MemberMultiSelect } from "@/components/shared";

export function CleaningTaskDialog({ open, onOpenChange, editing, form, setForm, members, roomOrder, saving, onSave, onDelete }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-y-auto rounded-3xl">
        <DialogHeader>
          <DialogTitle className="font-display">{editing ? "Edit task" : "New cleaning task"}</DialogTitle>
          <DialogDescription className="sr-only">Cleaning task details and schedule</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label>Title</Label>
            <Input
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
              placeholder="Vacuum the floor"
              className="rounded-xl"
              data-testid="cleaning-title-input"
            />
          </div>
          <div className="space-y-1.5">
            <Label>Room</Label>
            <Select value={form.room} onValueChange={(v) => setForm({ ...form, room: v })}>
              <SelectTrigger className="rounded-xl" data-testid="cleaning-room-select">
                <SelectValue placeholder="Pick a room" />
              </SelectTrigger>
              <SelectContent>
                {roomOrder.map((n) => (
                  <SelectItem key={n} value={n}>
                    {n}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5">
            <Label>Assign to</Label>
            <MemberMultiSelect
              members={members}
              value={form.member_ids}
              onChange={(ids) => setForm({ ...form, member_ids: ids })}
            />
          </div>
          <div className="space-y-1.5">
            <Label>Repeats</Label>
            <FrequencyPicker value={form} onChange={(v) => setForm({ ...form, ...v })} testIdPrefix="cleaning-freq" />
          </div>
        </div>
        <DialogFooter className="flex-row justify-between gap-2 sm:justify-between">
          {editing ? (
            <Button variant="ghost" className="rounded-xl text-destructive" onClick={onDelete} data-testid="cleaning-delete-btn">
              <Trash2 className="mr-1.5 h-4 w-4" /> Delete
            </Button>
          ) : (
            <span />
          )}
          <Button className="rounded-xl" onClick={onSave} disabled={saving} data-testid="cleaning-save-btn">
            {saving ? "Saving…" : "Save"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
